<template>
    <v-container fluid class="mt-0 pt-0">

        <v-row class="d-flex justify-center mt-0 pt-0">
            <v-col  lg="8" md="6" sm="12">
                <v-card class="elevation-6">
                    <v-card-text>
                        <v-toolbar :class="`block-t-xl`" text light justify="center" color="primary">
                            <v-list-item-title class="white--text">
                                <v-icon large class="mr-2" color="white">mdi-account</v-icon>
                                <h3>Στοιχεία λογαριασμού</h3>
                            </v-list-item-title>
							<v-spacer/>
							<v-tooltip right v-if="Object.keys($store.getters.homePageInformation.bookSupplier).length>0 && $store.getters.homePageInformation.bookSupplier.type === 'Ministry'">
								<template v-slot:activator="{ on }">
									<v-btn fab small v-on="on" @click="openPasswordDialog" color="secondary">
										<v-icon class="mr-1" color="black">mdi-lock-reset</v-icon>
									</v-btn>
								</template>
								<span>Αλλαγή Κωδικού</span>
							</v-tooltip>
                        </v-toolbar>

                        <v-divider></v-divider>
                        <div v-if="Object.keys($store.getters.homePageInformation.bookSupplier).length>0">
                            <v-row class="pt-2">
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Κωδικός Χρήστη" :value="loggedUser.id" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Τύπος Χρήστη" :value="returnSupplierType()" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Ίδρυμα" :value="loggedUser.institutionName" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Πιστοποιημένος από (τύπος)" :value="returnCertifierType()" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Διεύθυνση" :value="loggedUser.bookSupplierAddress" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Πιστοποιημένος από (όνομα)" :value="loggedUser.certifierName" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Τ.Κ." :value="loggedUser.bookSupplierZipCode" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Πόλη" :value="loggedUser.city" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Νομός" :value="loggedUser.prefecture" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Όνομα Υπεύθυνου" :value="loggedUser.contactName" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Κινητό Τηλέφωνο Υπεύθυνου" :value="loggedUser.contactMobilePhone" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Τηλέφωνο Υπεύθυνου" :value="loggedUser.phone" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="E-Mail Υπεύθυνου" :value="loggedUser.contactEmail" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Όνομα Εναλλακτικού Υπεύθυνου" :value="loggedUser.alternateContactName" readonly></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Κινητό Τηλέφωνο Εναλλακτικού Υπεύθυνου" :value="loggedUser.alternateContactMobilePhone" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="Τηλέφωνο Εναλλακτικού Υπεύθυνου" :value="loggedUser.alternateContactPhone" readonly></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="E-Mail Εναλλακτικού Υπεύθυνου" :value="loggedUser.alternateContactEmail" readonly></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field outlined hide-details dense label="E-Mail (γενικό)" :value="loggedUser.email" readonly></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
	<SetPasswordDialog/>
    </v-container>
</template>

<script>
	import SetPasswordDialog from "@/components/SetPasswordDialog.vue";

	export default {
		name: "Homepage",
		components: {SetPasswordDialog},
		data: () => ({
            bookSupplier: {},
        }),

        computed:{
			loggedUser:{
				get() {
					return this.$store.getters.homePageInformation.bookSupplier;
                }
            }
        },

		methods: {
			openPasswordDialog(){
				this.$store.commit('setPasswordDialog' , true);
			},

			returnSupplierType() {
				if(this.loggedUser.type === 'Ministry'){
					return 'Διαχειριστής';
                }else{
					return 'Υπεύθυνος Παραγγελίας Βιβλίων';
                }

			},
			returnCertifierType() {
				if(this.loggedUser.CertifierType === 'Chairman'){
					return 'Πρόεδρος';
                }else if(this.loggedUser.CertifierType === 'Dean'){
					return 'Πρύτανης';
				}else {
					return 'Άγνωστο';
				}

			},
		}
	}
</script>

<style scoped>
    .col-class {
        font-size: medium;
        font-weight: bold
    }
</style>